import React from 'react'
import { WarningCircle, ArrowsClockwise } from '@phosphor-icons/react'
import { logError } from '@/lib/log'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

export class PageErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logError('PageErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-6 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <WarningCircle size={32} className="text-red-500" />
          </div>
          <h2 className="text-[#3E3A37] text-xl font-medium mb-2 opacity-90">Sayfa Yüklenemedi</h2>
          <p className="text-[#3E3A37] text-sm opacity-60 mb-6">
            Lütfen internet bağlantınızı kontrol edip tekrar deneyin.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-6 py-3 bg-[#E4D5C7] text-[#3E3A37] rounded-xl font-medium transition-transform hover:scale-105 active:scale-95"
          >
            <ArrowsClockwise size={20} />
            Yeniden Dene
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
